import script from "./jiaoxueshejiadd.vue?vue&type=script&setup=true&lang=js"
export * from "./jiaoxueshejiadd.vue?vue&type=script&setup=true&lang=js"

import "./jiaoxueshejiadd.vue?vue&type=style&index=0&id=09de22aa&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09de22aa"]])

export default __exports__